var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page_mobile",
    transform: "translate(-348, -78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_menu",
    transform: "translate(348, 78)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    mask: "url(#mask-2)",
    fill: "#CFDAE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 5)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3764535,5.5 L0.623546512,5.5 C0.281126869,5.5 0,5.83359446 0,6.25 C0,6.66640554 0.281126869,7 0.623546512,7 L21.3764535,7 C21.7188731,7 22,6.66640554 22,6.25 C22,5.83359446 21.7188731,5.5 21.3764535,5.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3764535,0 L0.623546512,0 C0.281126869,0 0,0.333594457 0,0.75 C0,1.16640554 0.281126869,1.5 0.623546512,1.5 L21.3764535,1.5 C21.7188731,1.5 22,1.16640554 22,0.75 C22,0.333594457 21.7188731,0 21.3764535,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3764535,11 L0.623546512,11 C0.281126869,11 0,11.3335945 0,11.75 C0,12.1664055 0.281126869,12.5 0.623546512,12.5 L21.3764535,12.5 C21.7188731,12.5 22,12.1664055 22,11.75 C22,11.3335945 21.7188731,11 21.3764535,11 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.c1a3167a3ced4e2624d8e50feb91568d.svg";
export { ForwardRef as ReactComponent };